// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"Search_searchResult__2MZAT","loading":"Search_loading__2IPcr","searchIcon":"Search_searchIcon__2GRMl","searchContent":"Search_searchContent__3cWdd"};